"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderInputGlobally = exports.bmInputStyle = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _utils = require("./utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\tinput.bm-input {\n\t\tfont-size: 14px;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tpadding: 0.375em 0.75em;\n\t\tline-height: 1.5;\n\t\tbackground-clip: padding-box;\n\t\tborder: 1px solid #ced4da;\n\t\theight: 30px;\n\t\tborder-radius: 0;\n\t\tcolor: #37383d;\n\t\tbackground-color: #fff;\n\t\tborder-color: #b2b2b8;\n\t\ttransition: border-color ease-in-out 0.2s;\n\t\tpadding-top: 0;\n\t\tpadding-bottom: 0;\n\t\tmargin: 0;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t}\n\n\tinput.bm-input:focus {\n\t\tcolor: #495057;\n\t\tbackground-color: #fff;\n\t\tborder-color: #37383d;\n\t\toutline: 0;\n\t\tbox-shadow: none;\n\t}\n\n\tinput.bm-input[readonly] {\n\t\tcolor: #37383d;\n\t\tbackground-color: #fff;\n\t\tborder-color: #fff;\n\t\tfont-weight: 700;\n\t}\n\tinput.bm-input[disabled] {\n\t\tcolor: #606169;\n\t\tbackground-color: #f4f5f7;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var bmInputStyle = (0, _element.css)(_templateObject());
exports.bmInputStyle = bmInputStyle;

var renderInputGlobally = function renderInputGlobally() {
  return (0, _utils.renderStyleCssGlobally)(bmInputStyle, 'bmInputStyle');
};

exports.renderInputGlobally = renderInputGlobally;
